<ng-container *ngIf="heroData && heroData?.type === 'primary'">
  <div
    class="jb-hero-primary"
    [ngClass]="heroData?.theme === 'dark' ? 'bg-core-blue' : 'bg-off-white'"
    *ngIf="breadcrumbs"
  >
    <div class="page-margin jb-max-width center-l pt4" *ngIf="!!heroSearch">
      <jb-search-box-container
        [isInHero]="true"
        [searchSection]="heroSearch"
      ></jb-search-box-container>
    </div>

    <jb-hero
      jbSitemapNestedLinker
      [breadcrumbs]="breadcrumbs"
      [theme]="heroData?.theme"
      [imageSrc]="heroImage?.src"
    >
      <ng-container JbTitle>{{ heroData?.title }}</ng-container>
      <ng-container JbSubheader>
        {{ heroData?.subheader }}
      </ng-container>
      <ng-container JbDescription>
        {{ heroData?.copy }}
      </ng-container>
    </jb-hero>
  </div>
</ng-container>

<!-- catchall for empty `type` and 'secondary' -->
<ng-container *ngIf="heroData && heroData?.type !== 'primary'">
  <div
    class="jb-hero-secondary bg-off-white"
    [ngClass]="heroData?.theme === 'dark' ? 'bg-core-blue' : 'bg-off-white'"
    *ngIf="breadcrumbs"
  >
    <div class="page-margin jb-max-width center-l pt4" *ngIf="!!heroSearch">
      <jb-search-box-container
        [isInHero]="true"
        [searchSection]="heroSearch"
      ></jb-search-box-container>
    </div>

    <jb-hero
      *ngIf="heroData?.title || heroImage?.src; else noContent"
      jbSitemapNestedLinker
      [breadcrumbs]="breadcrumbs"
      [theme]="heroData?.theme"
      type="secondary"
    >
      <ng-container JbTitle>
        {{ heroData?.title }}
      </ng-container>
      <jb-icon
        *ngIf="heroImage"
        class="fill-core-blue"
        [name]="heroImage.src"
        width="64px"
        height="64px"
      >
      </jb-icon>
    </jb-hero>
    <ng-template #noContent>
      <div class="center jb-max-width page-margin">
        <jb-breadcrumbs
          [item]="breadcrumbs"
          [theme]="heroData?.theme"
        ></jb-breadcrumbs>
      </div>
    </ng-template>
  </div>
</ng-container>

<!-- NFS promo hero -->
<ng-container *ngIf="heroData && heroData?.type === 'promoHero'">
  <div class="relative flex-ns justify-center-ns">
    <jb-background
      *ngIf="heroData.backgroundColor"
      [color]="heroData.backgroundColor"
    >
    </jb-background>
    <jb-background
      *ngIf="heroData.backgroundImage"
      [repeat]="heroData.backgroundRepeat | jbBooleanFromString"
      [src]="heroData.backgroundImage || ''"
    >
    </jb-background>
    <div
      class="relative pv4 pv6-ns w-100-ns jb-grid jb-fare-sale-grid page-margin jb-max-width"
    >
      <div class="col-5-l col-6-m" [ngClass]="heroImage ? 'pb3 pb0-ns' : ' '">
        <jb-flag
          [theme]="heroData?.theme === 'dark' ? 'light' : 'dark'"
          class="mb2"
          [title]="heroData?.flagTitle"
        >
        </jb-flag>
        <h1
          class="mb0"
          [ngClass]="heroData?.theme === 'dark' ? 'white' : 'core-blue'"
        >
          {{ heroData?.title }}
        </h1>
      </div>
      <ng-container *ngIf="heroImage">
        <div class="col-4-l col-4-m h-100">
          <ng-container *ngIf="heroImage">
            <jb-image [src]="heroImage.src" [alt]="heroImage?.alt"> </jb-image>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
